import {Block} from '../models/Block';
import {Response, Result} from './models/Response';
import {TrainingPlanSaver} from '../ui/TrainingPlanEditorPresenter';
import {partEventsToApiEvents} from './support/partEventsToApiEvents';
import {PartEvent} from '../models/PartEvent';
import {MediaItem} from '../models/MediaItem';
import {partMediaItemsToApiMediaItems} from './support/partMediaItemsToApiMediaItems';
import {Chapter} from '../models/Chapter';
import {chaptersToApiChapters} from './support/chaptersToApiChapters';
import {DeviceRequirementRule} from '../models/DeviceRequirementRule';

export class UpdateTrainingPlanApi implements TrainingPlanSaver {
    constructor(private id: number) {}

    public async save(
        title: string,
        description: string | null,
        deviceRequirementRules: DeviceRequirementRule[],
        isPublished: boolean,
        blocks: Block[],
        partEvents: PartEvent[],
        chapters: Chapter[],
        mediaItems: MediaItem[],
    ): Promise<Response> {
        try {
            const rawResponse = await fetch(`/training/plan/${this.id}/edit`, {
                method: 'POST',
                headers: {
                    'X-Csrf-Token': (document as any).head.querySelector('meta[name="csrf-token"]').content,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title: title,
                    description: description,
                    device_requirement_rules: deviceRequirementRules,
                    is_published: isPublished,
                    blocks: blocks,
                    events: partEventsToApiEvents(blocks, partEvents),
                    chapters: chaptersToApiChapters(blocks, chapters),
                    mediaItems: partMediaItemsToApiMediaItems(blocks, mediaItems),
                }),
            });
            const data = await rawResponse.json();
            if (rawResponse.status === 200) {
                return {
                    result: Result.Success,
                    data: data,
                };
            }
            if (rawResponse.status === 422) {
                const errors: Array<{field: string; error: string}> = [];
                for (const key of Object.keys(data.errors)) {
                    errors.push({
                        field: key,
                        error: data.errors[key][0],
                    });
                }

                return {
                    result: Result.Validation,
                    errors: errors,
                };
            }
            return {
                result: Result.Error,
            };
        } catch (e) {
            return {
                result: Result.Error,
            };
        }
    }
}
